export const getButtonAriaLabel = (name: string, label: string) => {
  switch (name) {
    case "Accounting":
    case "Banking":
    case "Bank feeds":
    case "Commerce":
      return `Manage ${name.toLowerCase()} integrations`;
    case "Other integrations":
      return `Manage ${name.toLowerCase()}`;
    default:
      return label;
  }
};
